const t=(t,e,n={})=>{const o=new CustomEvent(t,{detail:{type:e,...n}});document.dispatchEvent(o)};export{t as default};
//# sourceMappingURL=sendCustomEvent.js.map
